import {
	CancelType,
	CreateCancelCancelTypeInput,
} from "@/main/gql/__generated__/graphql"

export const MIN_INVOICE_PRICE = 120

// TODO: 型を使ってswitchではない状態にしたい
// TODO: 手動だけでいい？
export const convertCancelTypeToCreateCancelCancelTypeInput = (
	cancelType: CancelType
): CreateCancelCancelTypeInput => {
	switch (cancelType) {
		case "NO_CONFIRMATION":
			return "NO_CONFIRMATION"
		case "ON_THE_DAY":
			return "ON_THE_DAY"
		case "PREVIOUS_DAY":
			return "PREVIOUS_DAY"
		case "TWO_DAYS_AGO":
			return "TWO_DAYS_AGO"
		case "FROM_PREVIOUS_DAY_TO_TWO_DAYS_AGO":
			return "FROM_PREVIOUS_DAY_TO_TWO_DAYS_AGO"
		case "THREE_DAYS_AGO":
			return "THREE_DAYS_AGO"
		case "SUBSCRIPTION_PAYMENT_FAILED":
			return "SUBSCRIPTION_PAYMENT_FAILED"
		case "SK_CLINIC_COUNSELING_FROM_ON_THE_DAY_TO_SEVEN_DAYS_AGO":
			return "SK_CLINIC_COUNSELING_FROM_ON_THE_DAY_TO_SEVEN_DAYS_AGO"
		case "SK_CLINIC_SURGERY_COUNSELING_FROM_ON_THE_DAY_TO_SEVEN_DAYS_AGO":
			return "SK_CLINIC_SURGERY_COUNSELING_FROM_ON_THE_DAY_TO_SEVEN_DAYS_AGO"
		case "SK_CLINIC_DERMATOLOGY_COUNSELING_FROM_ON_THE_DAY_TO_SEVEN_DAYS_AGO":
			return "SK_CLINIC_DERMATOLOGY_COUNSELING_FROM_ON_THE_DAY_TO_SEVEN_DAYS_AGO"
		case "SK_CLINIC_DENTAL_COUNSELING_FROM_ON_THE_DAY_TO_SEVEN_DAYS_AGO":
			return "SK_CLINIC_DENTAL_COUNSELING_FROM_ON_THE_DAY_TO_SEVEN_DAYS_AGO"
		case "SK_CLINIC_DENTAL_FROM_FOUR_DAYS_AGO_TO_SEVEN_DAYS_AGO":
			return "SK_CLINIC_DENTAL_FROM_FOUR_DAYS_AGO_TO_SEVEN_DAYS_AGO"
		case "SK_CLINIC_DENTAL_FROM_PREVIOUS_DAY_TO_THREE_DAYS_AGO":
			return "SK_CLINIC_DENTAL_FROM_PREVIOUS_DAY_TO_THREE_DAYS_AGO"
		case "SK_CLINIC_DENTAL_ON_THE_DAY":
			return "SK_CLINIC_DENTAL_ON_THE_DAY"
		case "SK_CLINIC_DERMATOLOGY_FROM_FOUR_DAYS_AGO_TO_SEVEN_DAYS_AGO":
			return "SK_CLINIC_DERMATOLOGY_FROM_FOUR_DAYS_AGO_TO_SEVEN_DAYS_AGO"
		case "SK_CLINIC_DERMATOLOGY_FROM_PREVIOUS_DAY_TO_THREE_DAYS_AGO":
			return "SK_CLINIC_DERMATOLOGY_FROM_PREVIOUS_DAY_TO_THREE_DAYS_AGO"
		case "SK_CLINIC_DERMATOLOGY_ON_THE_DAY":
			return "SK_CLINIC_DERMATOLOGY_ON_THE_DAY"
		case "SK_CLINIC_SURGERY_FROM_FOUR_DAYS_AGO_TO_SEVEN_DAYS_AGO":
			return "SK_CLINIC_SURGERY_FROM_FOUR_DAYS_AGO_TO_SEVEN_DAYS_AGO"
		case "SK_CLINIC_SURGERY_FROM_PREVIOUS_DAY_TO_THREE_DAYS_AGO":
			return "SK_CLINIC_SURGERY_FROM_PREVIOUS_DAY_TO_THREE_DAYS_AGO"
		case "SK_CLINIC_SURGERY_ON_THE_DAY":
			return "SK_CLINIC_SURGERY_ON_THE_DAY"
		case "SK_CLINIC_SURGICAL_FOLLOW_UP_FROM_ON_THE_DAY_TO_SEVEN_DAYS_AGO":
			return "SK_CLINIC_SURGICAL_FOLLOW_UP_FROM_ON_THE_DAY_TO_SEVEN_DAYS_AGO"
		case "SK_CLINIC_MANUAL_INVOICE_PRICE_SETTING":
			return "SK_CLINIC_MANUAL_INVOICE_PRICE_SETTING"
		case "MANUAL_INVOICE_PRICE_SETTING":
			return "MANUAL_INVOICE_PRICE_SETTING"
		case "UENO_CLINIC_PRICE":
			return "UENO_CLINIC_PRICE"
		case "UENO_CLINIC_SCHEDULE":
			return "UENO_CLINIC_SCHEDULE"
		case "UENO_CLINIC_FEAR":
			return "UENO_CLINIC_FEAR"
		case "UENO_CLINIC_FAMILY_CONSULTATION":
			return "UENO_CLINIC_FAMILY_CONSULTATION"
		case "UENO_CLINIC_OTHER":
			return "UENO_CLINIC_OTHER"
		case "UENO_CLINIC_CONFIRMED_CANCEL_PRICE":
			return "UENO_CLINIC_CONFIRMED_CANCEL_PRICE"
		case "UENO_CLINIC_CONFIRMED_CANCEL_SCHEDULE":
			return "UENO_CLINIC_CONFIRMED_CANCEL_SCHEDULE"
		case "UENO_CLINIC_CONFIRMED_CANCEL_FEAR":
			return "UENO_CLINIC_CONFIRMED_CANCEL_FEAR"
		case "UENO_CLINIC_CONFIRMED_CANCEL_FAMILY_CONSULTATION":
			return "UENO_CLINIC_CONFIRMED_CANCEL_FAMILY_CONSULTATION"
		default:
			throw new Error(`Invalid cancelType: ${cancelType}`)
	}
}
